import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { AuthService } from 'src/app/service/auth.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss'],
})
export class ScannerComponent {
  constructor(
    private router: Router,
    public routing: RoutingService,
    public auth: AuthService,
    public portfolioApi: PortfolioApiService,
  ) {}

  openPortfolioBoard() {
    this.router.navigate(['/cockpit/news/portfolio/main'], {
      replaceUrl: false,
    });
  }
}
